var FeedItemType;
(function (FeedItemType) {
    FeedItemType["POLL"] = "poll";
    FeedItemType["RECOGNITION"] = "recognition";
})(FeedItemType || (FeedItemType = {}));
export default FeedItemType;
